import { render, staticRenderFns } from "./AndamandaPayListPage.vue?vue&type=template&id=56cb4d5c&scoped=true"
import script from "./AndamandaPayListPage.vue?vue&type=script&lang=js"
export * from "./AndamandaPayListPage.vue?vue&type=script&lang=js"
import style0 from "./AndamandaPayListPage.vue?vue&type=style&index=0&id=56cb4d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb4d5c",
  null
  
)

export default component.exports